var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "uploadImage"
  }, [_c('el-drawer', {
    attrs: {
      "title": _vm.drawerInfo.title,
      "direction": _vm.drawerInfo.direction || 'rtl',
      "visible": _vm.drawerInfo.visible
    },
    on: {
      "update:visible": function ($event) {
        return _vm.$set(_vm.drawerInfo, "visible", $event);
      }
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('el-divider'), _c('div', {
    staticClass: "addBox"
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "#",
      "accept": "image/*",
      "disabled": _vm.uploading,
      "show-file-list": false,
      "http-request": _vm.uploadFileBySDK,
      "on-change": _vm.handleChange,
      "before-upload": _vm.judgeAllowUpload
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-plus",
      "loading": _vm.uploading
    }
  }, [_vm._v(_vm._s(_vm.$t('addTvuOne.adds')))])], 1)], 1), _c('div', {
    staticClass: "imageBox"
  }, [_c('p', {
    staticClass: "listTitle"
  }, [_vm._v(_vm._s(_vm.$t('galleryHost.imageList')))]), _c('div', {
    staticClass: "imageContent scrollbar"
  }, [_c('draggable', {
    on: {
      "change": _vm.changeImageArray,
      "end": _vm.dragEnd
    },
    model: {
      value: _vm.uploadImageArray,
      callback: function ($$v) {
        _vm.uploadImageArray = $$v;
      },
      expression: "uploadImageArray"
    }
  }, [_c('transition-group', _vm._l(_vm.uploadImageArray, function (item) {
    return _c('div', {
      key: item.id,
      staticClass: "list",
      class: _vm.showActive(item),
      on: {
        "click": function ($event) {
          return _vm.selectPicture(item);
        }
      }
    }, [_c('el-progress', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: item.fileName && !item.url,
        expression: "item.fileName && !item.url"
      }],
      attrs: {
        "type": "circle",
        "color": "#33AB4F",
        "percentage": _vm.uploadImagePercent[item.fileName]
      }
    }), _c('div', {
      staticClass: "imageBox"
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: item.url,
        expression: "item.url"
      }],
      class: _vm.imageClass(item),
      attrs: {
        "src": item.url
      }
    }), _c('span', {
      staticClass: "ellipsis imageName",
      attrs: {
        "title": item.name
      }
    }, [_vm._v(_vm._s(item.name))]), _c('i', {
      staticClass: "el-icon-s-fold"
    }), _c('el-popover', {
      ref: `deletePopper_${item.id}`,
      refInFor: true,
      attrs: {
        "placement": "bottom",
        "trigger": "click",
        "width": "220",
        "popper-class": "deletePopper"
      }
    }, [_c('i', {
      staticClass: "el-icon-delete",
      attrs: {
        "slot": "reference"
      },
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return (() => {}).apply(null, arguments);
        }
      },
      slot: "reference"
    }), _c('div', {
      staticClass: "content"
    }, [_c('p', [_vm._v(_vm._s(_vm.$t('kioskHost.deleteUploadImage')))]), _c('div', {
      staticClass: "contentFoot"
    }, [_c('span', {
      staticClass: "cancelBtn",
      on: {
        "click": function ($event) {
          return _vm.hideDeletePopover(item.id);
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('commonFunction.cancel')))]), _c('span', {
      staticClass: "deleteBtn",
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.deleteUpload(item);
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('tagName.del')))])])])])], 1)], 1);
  }), 0)], 1)], 1)])], 1)])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };